import { render, staticRenderFns } from "./ProsicVideos.vue?vue&type=template&id=13e7d618&"
import script from "./ProsicVideos.vue?vue&type=script&lang=js&"
export * from "./ProsicVideos.vue?vue&type=script&lang=js&"
import style0 from "./ProsicVideos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports